import { render, staticRenderFns } from "./TGMSTD0021.vue?vue&type=template&id=196a2baf&scoped=true&"
import script from "./TGMSTD0021.js?vue&type=script&lang=js&"
export * from "./TGMSTD0021.js?vue&type=script&lang=js&"
import style0 from "./TGMSTD0021.vue?vue&type=style&index=0&id=196a2baf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196a2baf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VFooter,VRow,VSpacer})
